<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">

            <b-form-group label="Search:">
              <b-form-input v-model="formFilters.search" />
            </b-form-group>
            <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
             </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <b-row class="align-items-end">
          <div class="col">
            <h1 class="header-title">
              Order Groups
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(projectId)="data">
                <span
                  v-if="myProjects && myProjects.find(a => a.id == data.item)"
                  >{{ myProjects.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item)"
                  >{{ myBrands.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(warehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                  >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <router-link
              v-if="is('developer') && has('pm.storefront.orderGroups.addOrUpdate')"
              :to="{ name: 'Storefronts.OrderGroups.Create' }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </b-row>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >

        <template v-slot:cell(id)="data">
          <div class="d-flex">
              <b-button variant="secondary mr-2"
                :to="{
                  name: 'Storefronts.OrderGroups.Edit',
                  params: { id: data.item.id }
                }"
              >
                Edit
              </b-button>
          </div>
        </template>
        <template v-slot:cell(projectId)="data">
          <span
            v-if="myProjects && myProjects.find(a => a.id == data.item.projectId)"
            >{{ myProjects.find(a => a.id == data.item.projectId).name }}</span
          >
          <span v-else>-</span>
        </template>
        <template v-slot:cell(createDate)="data">
          <span
            v-if="
              data.item.createDate &&
                !data.item.createDate.endsWith('Z')
            "
            >{{
              (data.item.createDate + 'Z')
                | moment('MMM Do YY, h:mm a')
            }}</span
          >
          <span v-else-if="data.item.createDate">{{
            data.item.createDate | moment('MMM Do YY, h:mm a')
          }}</span>
        </template>
        <template v-slot:cell(ordersAwaitingPayment)="data">
          <router-link
            :to="{
              name: 'Orders.Index',
              query: {
                projectId: data.item.id,
                orderStatus: 'awaiting_payment'
              }
            }"
          >
            {{ data.item.ordersAwaitingPayment }}
          </router-link>
        </template>

        <template v-slot:cell(ordersOnHold)="data">
          <router-link
            :to="{
              name: 'Orders.Index',
              query: { projectId: data.item.id, orderStatus: 'on_hold' }
            }"
          >
            {{ data.item.ordersOnHold }}
          </router-link>
        </template>

        <template v-slot:cell(ordersAwaitingShipment)="data">
          <router-link
            :to="{
              name: 'Orders.Index',
              query: {
                projectId: data.item.id,
                orderStatus: 'awaiting_shipment'
              }
            }"
          >
            {{ data.item.ordersAwaitingShipment }}
          </router-link>
        </template>

        <template v-slot:cell(ordersPendingFullfilment)="data">
          <router-link
            :to="{
              name: 'Orders.Index',
              query: {
                projectId: data.item.id,
                orderStatus: 'pending_fulfillment'
              }
            }"
          >
            {{ data.item.ordersPendingFullfilment }}
          </router-link>
        </template>

    </TableListing>
  </section>
</template>

<script>
import { TableListing, ActiveFiltersCard } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Storefronts.OrderGroups.Index',
  mixins: [crudMixinGen('orderGroups'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },

  watch: {},
  computed: {
  },
  data: () => ({
    fields: [
        { key: 'projectId', label: 'Storefront', sortable: false },
        { key: 'storeName', label: 'Name', sortable: false },
        { key: 'integrationStatus', label: 'Status', sortable: false },
        { key: 'createDate', label: 'Created at', sortable: false },
        { key: 'id', label: 'Action', sortable: false }
    ]
  }),
  mounted() {
    this.loadItems();
  },

  methods: {
  }
};
</script>
